import { chinaProject } from "./devices";

/**
 * Generates the correct environmentId to be used for generating backend service baseUrls and such
 * In china it returns the resource group (`"dev" | "prod"`),
 * and in global it return the GCP project id (something like `ikea-coworker-app-dev`)
 */
export function getEnvironmentId(): string {
  return (
    chinaProject() ??
    import.meta.env["GCLOUD_PROJECT"] ??
    import.meta.env["VITE_APP_PROJECT_ID"] ??
    ""
  );
}
